module.exports = __webpack_public_path__ + "img/google_play_badge_fr.56b02f15.png";